import * as d3 from 'd3';
import { differenceInDays } from 'date-fns';
export function intervalAndFormat(range) {
    var diff = Math.abs(differenceInDays.apply(void 0, range));
    switch (true) {
        case diff <= 1:
            return {
                intervals: 6,
                tickCount: 8,
                format: d3.timeFormat('%a, %H:%M')
            };
        case diff <= 3:
            return {
                intervals: 12,
                tickCount: 6,
                format: d3.timeFormat('%a, %H:%M')
            };
        default:
            return {
                intervals: 24,
                tickCount: 8,
                format: d3.timeFormat('%b %d, %a')
            };
    }
}
//# sourceMappingURL=IntervalGuides.utils.js.map